import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import { H5 } from '../../AbstractElements';

const Users = () => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const [users, setUsers] = useState([
        { id: 1, name: 'Admin User', email: 'admin@example.com', role: 'Admin', branch: 'Head Office' },
        { id: 2, name: 'Manager DXB', email: 'manager@dxb.com', role: 'Manager', branch: 'Dubai Branch' }
    ]);

    return (
        <div className="page-body">
            <Breadcrumbs parent="General" title="User Management" pageTitle="Users" />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between">
                                <H5>System Users</H5>
                                <Button color="primary" onClick={toggle}>Add User</Button>
                            </CardHeader>
                            <CardBody>
                                <Table hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            <th>Branch</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((u) => (
                                            <tr key={u.id}>
                                                <td>{u.name}</td>
                                                <td>{u.email}</td>
                                                <td>{u.role}</td>
                                                <td>{u.branch}</td>
                                                <td>
                                                    <Button size="sm" color="danger">Delete</Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Add New User</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input placeholder="Full Name" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input type="email" placeholder="Email Address" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Role</Label>
                            <Input type="select">
                                <option>User</option>
                                <option>Manager</option>
                                <option>Admin</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Branch</Label>
                            <Input type="select">
                                <option>Head Office</option>
                                <option>Dubai Branch</option>
                            </Input>
                        </FormGroup>
                        <Button color="primary" block>Create User</Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default Users;
